import { render, staticRenderFns } from "./TabFrame.vue?vue&type=template&id=1daf7caa&"
import script from "./TabFrame.vue?vue&type=script&lang=js&"
export * from "./TabFrame.vue?vue&type=script&lang=js&"
import style0 from "./TabFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports